import GenreTagList from "./GenreTagList";

export default GenreTagList;
